<ng-select
  #dropdown
  [items]="items"
  bindLabel="label"
  bindValue="label"
  [(ngModel)]="selectedValue"
  [clearable]="false"
  [searchable]="true"
  [typeahead]="searchTerm$"
  [loading]="isLoading"
  (change)="onChange($event)"
  [appendTo]="'body'"
  placeholder="Search location...">
</ng-select>
